import {
  IconButton,
  Menu,
  Surface,
  useClickAwayListener,
  useMagnet,
} from '@mint/ui';
import React, { useCallback, useMemo, useState } from 'react';
import { AdminActionGrow } from '../admin-action-grow';
import { AdminTableActionButtonContext } from './admin-table-action-button-context';
import { AdminTableActionButtonProps } from './admin-table-action-button-props';
import { MoreIcon } from '@mint/icons';
import styled from 'styled-components';

const Div = styled.div`
  position: relative;
  width: 17px;
`;

const IC = styled(IconButton)`
  border-radius: 0.5rem;
  font-size: 0.75rem;
  height: 1.5rem;
  line-height: 1.5rem;
  width: 1.5rem;
`;

export const AdminTableActionButton: React.FunctionComponent<
  AdminTableActionButtonProps
> = props => {
  const { color, children } = props;
  const [actionsVisible, setActionsVisible] = useState(false);
  const [, style] = useMagnet({ anchor: 'north-east', position: 'inside' });

  const ref = useClickAwayListener((): void => setActionsVisible(false), {
    enabled: actionsVisible,
  });

  const openDropdown = useCallback(() => {
    setActionsVisible(true);
  }, []);

  const closeDropdown = useCallback(() => {
    setActionsVisible(false);
  }, []);

  const context = useMemo(
    () => ({
      close: closeDropdown,
      open: openDropdown,
    }),
    [openDropdown, closeDropdown],
  );

  return (
    <Div ref={ref}>
      <IC onClick={openDropdown} color={color}>
        <MoreIcon />
      </IC>
      <AdminActionGrow
        onClick={closeDropdown}
        in={actionsVisible}
        style={{ ...props.style, ...style }}
      >
        <Surface z={8}>
          <AdminTableActionButtonContext.Provider value={context}>
            <Menu>{children}</Menu>
          </AdminTableActionButtonContext.Provider>
        </Surface>
      </AdminActionGrow>
    </Div>
  );
};
